/* eslint-disable */
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
import toast from '../../services/toast';
import Multiselect from 'vue-multiselect'
import allCountries from './phoneCodeList.json';
Vue.component('multiselect', Multiselect)
import { mapGetters } from "vuex";
export default {
  name: 'global-all-user-message',
  components: {
    Multiselect
  },
  props: [],
  data () {
    return {
      selectUser:'',
      users:[],
      subject:'Mobile Sms',
      message:'',
      userList:null,
      userListResults:[], 
      value: [],
      options: [],
      submitted:false,
      multiselect:false,
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        }
      },
      confirmedSendMail:false,
      preview_box:false,
      UnsubscribedMultiple:false,
      unsubScribedmultiple:'',
      unsubScribedmultipleMail:[],
      unsubScribedmultiple_popup:false,
      excelImportDataList:[],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      sms_msg:'',
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      confirmationDelieveredPopup:false
    }
  },
  computed: {
    ...mapGetters([
      'getAllUserListGetters'
    ]),
    getUserList() {
      this.userList = this.$store.getters.getAllUserListGetters.data
      return
    },
    setIntialsState(){
      if(this.userList){
        this.userListResults = this.userList
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
      return
    }
  },
  mounted () {
    this.getUserCountry();
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserList
    this.setIntialsState
  },
  methods: {
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    onChange(value) {
      if(this.selectUser == 'Select Multiple'){
        this.multiselect = true
        this.UnsubscribedMultiple = false
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        this.multiselect = false
        this.UnsubscribedMultiple = true
        this.value = ''
        setTimeout(()=>{
          $('.option-list').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).find('ul').slideToggle(100);
            if ($(this).hasClass('open')) {
              $('.dropdown-arrow').text('▼');
            } else {
              $('.dropdown-arrow').text('▲');
            }
          });
          $(document).on('click', function(e) {
            var container = $('.option-list');
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              container.removeClass('open');
              $('.dropdown-arrow').text('▲');
              container.find('ul').slideUp(100);
            }
          })
        },100)
      }else{
        this.multiselect = false
        this.UnsubscribedMultiple = false
        this.value = ''
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }
    },
    validateCreateMblSmsBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.confirmedSendMail = true
          $('body').addClass('email_sent_popup')
        }
      });
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    yesConfirmed(){
      this.submitted = true;
      if(this.selectUser == 'Select Multiple'){
        for(var i = 0; i < this.value.length; i++){
          this.users.push(this.value[i].id)
        }
        let data = {
          subject: this.subject,
          message: this.sms_msg,
          users:this.users,
          type:'mobile'
        }
        this.$store.dispatch('sentMultipleUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.sms_msg = ''
          this.users = []
          this.value = []
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        let data = {
          subject: this.subject,
          message: this.sms_msg,
          type:'mobile',
          users:[
            {mobile_country_code:'+' + this.phone.countryCode,
            mobile:this.phone.number}
          ],
        }
        this.$store.dispatch('sentUnsubscribedMultipleUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.sms_msg = ''
          this.users = []
          this.value = []
          this.phone.number = ''
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else if(this.selectUser == 'Testing'){
        let data = {
          subject: this.subject,
          type:'mobile',
          message: this.sms_msg,
        }
        this.$store.dispatch('staffUserMailForTestingFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.sms_msg = ''
          this.users = []
          this.value = []
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }else{
        let data = {
          subject: this.subject,
          type:'mobile',
          message: this.sms_msg,
        }
        this.$store.dispatch('sentAllUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.sms_msg = ''
          this.users = []
          this.value = []
          this.$validator.reset();
          this.confirmationDelieveredPopup = true
          $('body').addClass('body_right_scroll_remove')
        }).catch((err) => {})
      }
      return;
    },
    confirmationDelieveredPopupClose(){
      this.confirmationDelieveredPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    cancleConfirmed(){
      $('body').removeClass('email_sent_popup')
      this.submitted = false;
      this.confirmedSendMail = false
    },
    previewBtn(){
      this.preview_box = true
      $('body').addClass('email_sent_popup')
      setTimeout(()=>{
        document.getElementById("mailcode").innerHTML = this.sms_msg;
      },200)
    },
    closePreviewBtn(){
      this.preview_box = false
      $('body').removeClass('email_sent_popup')
    },
    unsubScribedmultipleMailPopupFun(){
      this.unsubScribedmultiple_popup = true
      $('body').addClass('email_sent_popup')
    },
    unsubScribedmultipleMailClosePopupFun(){
      this.unsubScribedmultiple_popup = false
      $('body').removeClass('email_sent_popup')
      // document.getElementById("importEmail").value = null;
    },
    unsubScribedmultipleFun(e){
      this.unsubScribedmultipleMail.push(this.unsubScribedmultiple)
      this.unsubScribedmultiple = ''
      this.$validator.reset();
    },
    removeAttributes : function (index) {
      Vue.delete(this.unsubScribedmultipleMail, index);
    },
    isEmailValid(email) {
      return this.reg.test(email);
    },
    removeImportAttributes (index) {
      Vue.delete(this.excelImportDataList, index);
      
    },
    removeImportAttributesInPopup (index) {
      Vue.delete(this.excelImportDataList, index);
      if(this.excelImportDataList.length == 1){document.getElementById("importEmail").value = null;}
      
    },
    addImportedEMailFun(e){
      this.unsubScribedmultipleMail.push(this.excelImportDataList)
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
      this.$validator.reset();
    },
    removeImportedEMailFun(){
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
    }
  },
  watch:{
    getUserList() {
      return this.$store.getters.getAllUserListGetters.data
    },
    userList(old_val, new_val){
      if(new_val == undefined){
        this.userListResults = old_val
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    },
  },
}